import { addOrderInfo } from './index';
import chengeBuyLink from '../eMarket/chengeBuyLink';
import { reachMetrikaGoal } from '../variables';
const summery = () => {
    const props = document.querySelector('[data-element="option_props"]');
    if (!props) {
        return false;
    }
    const options = props.querySelectorAll('input');
    const summeryProps = document.querySelector('#summeryProps');
    const emptyOption = summeryProps.querySelector('#empty-option');
    const bSummeryPrice = document.querySelector('#summery-price .price');
    const bProductPrice = document.querySelector('.product-page__actual-price');
    const productPrice = parseInt(bProductPrice.dataset.price);
    let optionSelectSent = false; // TST-028: OPTION_SELECT — один раз за просмотр страницы
    const handler = (event) => {
        const input = event.target;
        if (!optionSelectSent) {
            optionSelectSent = true;
            reachMetrikaGoal('OPTION_SELECT');
        }
        const summeryOption = summeryProps.querySelector(`[data-propid='${input.id}']`);
        if (input.checked) {
            summeryOption.classList.remove('hide');
        }
        else {
            summeryOption.classList.add('hide');
        }
        const status = checkOptions();
        if (status == 'filled') {
            emptyOption.classList.add('hide');
        }
        else {
            emptyOption.classList.remove('hide');
        }
        bSummeryPrice.innerText = getSummeryPrice().toString();
        addOrderInfo();
        chengeBuyLink();
    };
    const checkOptions = () => {
        let status = 'empty';
        options.forEach(option => {
            if (option.checked) {
                status = 'filled';
            }
        });
        return status;
    };
    const getSummeryPrice = () => {
        let sum = productPrice;
        options.forEach(option => {
            if (option.checked) {
                sum += parseInt(option.dataset.price);
            }
        });
        return new Intl.NumberFormat("ru-RU").format(sum);
    };
    options.forEach(option => {
        option.addEventListener('change', handler);
    });
};
export default summery;
